
module.exports = function getResource(label, vars = []) {
    let resources = {
        selectDay: 'Please select a day',
        prev: 'Previous',
        next: 'Next'
    };
    return resources[label];
};
